<button
  class="no-style container"
  [class.clickable]="chapterLink()"
  (click)="goToChapter(chapter().title)">
  @if (!simple()) {
    <div
      class="icon-wrapper"
      animate.enter="expand"
      animate.shrink="shrink"
      [class.contrast]="contrast()"
      [class.active]="active()"
      [class.no-margin]="noMargin()">
      <div
        class="icon"
        [ngStyle]="{ 'background-image': 'url(' + iconUrl + ')' }"></div>
    </div>
  }
  @if (chapterLink()) {
    <p class="bold">{{ chapter().title }}</p>
  }
</button>
